/**
 * sw-pr-gw-customer-dashboard
 * SpendWyze Payment Request Gateway Customer Dashboard
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Request body of login with magic link endpoint
 */
export interface LoginWithMagicLinkRequestBody { 
    /**
     * Email address of the user
     */
    emailAddress: string;
}